import { getAssetUrl } from "@client/lib/assets";
import { connectCustom } from "@client/lib/misc";
import { type BaseAppState, MediaType } from "@client/types";
import Component, { type ImageProps } from "./component";

const mapStateToProps = (state: BaseAppState, { src, ...props }: ImageProps): ImageProps => {
  return {
    ...props,
    src: getAssetUrl(src, MediaType.Image)
  };
};

export default connectCustom(mapStateToProps, null, { forwardRef: true })(Component);
